import { inventoryAdjustmentReasonIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";
import { inventoryAdjustmentReasonDirectionSchema } from "./direction";

export const createInventoryAdjustmentReason = {
  name: "createInventoryAdjustmentReason" as const,
  input: z.object({
    name: z.string().min(1),
    direction: inventoryAdjustmentReasonDirectionSchema.nullable(),
  }),
  output: z.object({ id: inventoryAdjustmentReasonIdFormat.schema }),
};
